import React from "react";
import useCachedLoadCurrentPersonInfo from "./useCachedLoadCurrentPersonInfo";
import useService from "./useService";
const useCurrentPersonInfo = () => {
    const [personProfile, loadPersonInfo] = useService(useCachedLoadCurrentPersonInfo());
    React.useEffect(() => {
        loadPersonInfo();
    }, [loadPersonInfo]);
    return personProfile;
};
export default useCurrentPersonInfo;
